import { useEffect, useState } from "react";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import { viewTickets } from "./config";
import userStore from "../../zustand/userStore";
import { useDispatch, useSelector } from "react-redux";
import { getTicketsList } from "./redux/ticketingSlice";
import CommonTableTicketing from "./Common-table";
// export default function ViewTickets() {
//   const [tableData, setTableData] = useState([]);
//   const userData = userStore((state) => state.user);
//   //   console.log(userData);
//   function formatDateTime(timestamp) {
//     const date = new Date(timestamp);

//     const options = {
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//       hour: "2-digit",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true, // ✅ Enables AM/PM
//       timeZone: "Asia/Kolkata", // You can adjust based on location
//     };

//     return date.toLocaleString("en-IN", options);
//   }
//   // const API_URL = "https://web1024.docmaster.in:4501/api/externalUser/ticket";

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const response = await fetch(
//           // "https://web1024.docmaster.in:4500/api/user/ticket/getTicketsByUserId",
//           // `http://localhost:4501/api/contentUser/ticket/getTicketsByUserId/${userData.id}`,
//           `${viewTickets}/${userData.id}`,
//           {
//             method: "GET",
//             // headers: {
//             //   "Content-Type": "application/json",
//             // },
//             // body: JSON.stringify({ user_id: userData.id }),
//           }
//         );

//         const data = await response.json();
//         console.log("API response:", data);

//         const result = data.data || data;
//         if (Array.isArray(result)) {
//           setTableData(
//             result.map((each) => ({
//               ticket_id: each.ticket_id,
//               issue: each.issue_name,
//               description: each.description || "-",
//               status: each.ticket_status_name,
//               created_at: formatDateTime(each.raised_at),
//               // updated_at: formatDateTime(each.updated_at),
//             }))
//           );
//         } else {
//           console.warn("Unexpected data format", result);
//           setTableData([]); // Reset to empty array if data is not in expected format
//         }
//       } catch (error) {
//         console.error("Fetch error:", error);
//       }
//     }

//     fetchData();
//   }, [userData.id]);

//   const tableColumns = [
//     { accessor: "ticket_id", Header: "Ticket ID" },
//     { accessor: "issue", Header: "Issue" },
//     { accessor: "description", Header: "Description" },
//     { accessor: "status", Header: "Status" },
//     { accessor: "created_at", Header: "Created At" },
//     // { accessor: "updated_at", Header: "Updated At" },
//   ];

//   return (
//     <div>
//       {" "}
//       <h3 style={{ fontSize: "16px", marginTop: "1%" }}>
//         <strong>View Ticket (s)</strong>
//       </h3>
//       {tableData && tableData.length > 0 ? (
//         <div
//           style={{
//             width: "100%",
//             padding: "20px",
//             height: "75vh",
//             overflow: "auto",
//             border: "1px solid rgb(230,233,237)",
//           }}
//         >
//           <AllFeatureDataTable
//             columns={tableColumns}
//             data={tableData}
//             customPlaceHolder={"search"}
//           />
//         </div>
//       ) : (
//         "No tickets found"
//       )}
//     </div>
//   );
// }
export default function ViewTickets() {
  const userData = userStore((state) => state.user);
  const { ticketsList } = useSelector((state) => state.tickets);
  const dispatch = useDispatch();

  function formatDateTime(timestamp) {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // ✅ Enables AM/PM
      timeZone: "Asia/Kolkata", // You can adjust based on location
    };

    return date.toLocaleString("en-IN", options);
  }

  const tableColumns = [
    { key: "ticket_id", label: "Ticket ID" },
    { key: "issue", label: "Issue" },
    { key: "description", label: "Description" },
    { key: "status", label: "Status" },
    { key: "created_at", label: "Created At" },
  ];
  useEffect(() => {
    if (userData?.admin_id) {
      dispatch(getTicketsList({ user_id: userData.admin_id }));
    }
  }, [dispatch, userData]);
  const tableData = ticketsList
    ? ticketsList.map((each) => ({
        ticket_id: each.ticket_id,
        issue: each.issue_name,
        description: each.description || "-",
        status: each.ticket_status_name,
        created_at: formatDateTime(each.raised_at),
      }))
    : [];

  return (
    <div>
      {/* Usr :{JSON.stringify(userData)} */}
      {tableData && tableData.length > 0 ? (
        <div
          style={{
            width: "100%",
            padding: "20px",
            height: "75vh",
            overflow: "auto",
            border: "1px solid rgb(230,233,237)",
          }}
        >
          <h3 style={{ fontSize: "20px", marginTop: "1%" }}>View Ticket (s)</h3>
          <CommonTableTicketing
            columns={tableColumns}
            data={tableData}
            // customPlaceHolder={`${tableData}.length records`}
          />
        </div>
      ) : (
        "No tickets found"
      )}
    </div>
  );
}
